import { render, staticRenderFns } from "./CPageStaffIndexStandard.vue?vue&type=template&id=392d9642&"
import script from "./CPageStaffIndexStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageStaffIndexStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports